import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Youtube, Mail, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#05080A] text-white pt-20 pb-10 border-t border-white/10" data-id="element-271">
      <div className="container mx-auto px-6" data-id="element-272">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-273">
          {/* Brand */}
          <div data-id="element-274">
            <img src="https://cdn.magicpatterns.com/uploads/kEvjjfeq9ckri24mEFMCRs/HOF-logo.png" alt="House of Flavors" className="h-24 w-auto mb-6" data-id="element-275" />
            <div className="flex space-x-4" data-id="element-276">
              <a href="#" className="text-gray-400 hover:text-[#DDA247] transition-colors" data-id="element-277">
                <Instagram size={20} data-id="element-278" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#DDA247] transition-colors" data-id="element-279">
                <Facebook size={20} data-id="element-280" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#DDA247] transition-colors" data-id="element-281">
                <Twitter size={20} data-id="element-282" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#DDA247] transition-colors" data-id="element-283">
                <Youtube size={20} data-id="element-284" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-285">
            <h3 className="text-[#DDA247] font-bold tracking-widest mb-6 text-sm uppercase" data-id="element-286">
              Quick Links
            </h3>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-287">
              <li data-id="element-288">
                <Link to="/events" className="hover:text-white transition-colors" data-id="element-289">
                  Events
                </Link>
              </li>
              <li data-id="element-290">
                <Link to="/contact" className="hover:text-white transition-colors" data-id="element-291">
                  Corporate Events
                </Link>
              </li>
              <li data-id="element-292">
                <Link to="/bottle-service" className="hover:text-white transition-colors" data-id="element-293">
                  Bottle Service
                </Link>
              </li>
              <li data-id="element-294">
                <a href="https://www.ubereats.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-295">
                  Food Reservation
                </a>
              </li>
              <li data-id="element-296">
                <Link to="/book-now" className="hover:text-white transition-colors" data-id="element-297">
                  Hookah Booking
                </Link>
              </li>
            </ul>
          </div>

          {/* Venues */}
          <div data-id="element-298">
            <h3 className="text-[#DDA247] font-bold tracking-widest mb-6 text-sm uppercase" data-id="element-299">
              Venues
            </h3>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-300">
              <li data-id="element-301">
                <Link to="/gallery" className="hover:text-white transition-colors" data-id="element-302">
                  Daytime
                </Link>
              </li>
              <li data-id="element-303">
                <Link to="/gallery" className="hover:text-white transition-colors" data-id="element-304">
                  Nightlife
                </Link>
              </li>
              <li data-id="element-305">
                <Link to="/after-hours" className="hover:text-white transition-colors" data-id="element-306">
                  After Hours
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-307">
            <h3 className="text-[#DDA247] font-bold tracking-widest mb-6 text-sm uppercase" data-id="element-308">
              Contact
            </h3>
            <ul className="space-y-4 text-sm text-gray-400" data-id="element-309">
              <li className="flex items-start" data-id="element-310">
                <MapPin className="w-5 h-5 mr-3 text-[#DDA247] shrink-0" data-id="element-311" />
                <span data-id="element-312">
                  13460 Baltimore Ave
                  <br data-id="element-313" />
                  Laurel, Maryland 20707
                </span>
              </li>
              <li className="flex items-center" data-id="element-314">
                <Phone className="w-5 h-5 mr-3 text-[#DDA247] shrink-0" data-id="element-315" />
                <span data-id="element-316">(301) 555-0100</span>
              </li>
              <li className="flex items-center" data-id="element-317">
                <Mail className="w-5 h-5 mr-3 text-[#DDA247] shrink-0" data-id="element-318" />
                <span data-id="element-319">info@houseofflavors.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500" data-id="element-320">
          <p data-id="element-321">
            &copy; {new Date().getFullYear()} House of Flavors. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-322">
            <a href="#" className="hover:text-white transition-colors" data-id="element-323">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-324">
              Terms of Use
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-325">
              Accessibility
            </a>
          </div>
        </div>
      </div>
    </footer>;
}